import { Box, Heading } from "@vinomofo/components";

import { FONT_FAMILIES } from "../../styles";
import { TimerDisplay } from "./TimerDisplay";

const { dmSans } = FONT_FAMILIES;

interface CountdownTimerProps {
  dateTime?: string;
  title?: string;
  isExpandedDisplay: boolean;
  textColor?: string;
}

const InlineCountdownTimer = ({
  dateTime,
  title,
  isExpandedDisplay,
  textColor,
}: CountdownTimerProps) => {
  if (!dateTime) {
    return null;
  }

  return (
    <Box
      mb={3}
      padding={["0px", "10px", "0px", "10px"]}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {title && (
        <Box mr={2}>
          <Heading
            fontSize={["16px", "20px", "24px"]}
            color={textColor}
            fontWeight="700"
            fontFamily={dmSans}
            lineHeight={["100%", "132%", "132%"]}
            letterSpacing={"-1px"}
          >
            {title}
          </Heading>
        </Box>
      )}
      <TimerDisplay dateTime={dateTime} isExpandedDisplay={isExpandedDisplay} />
    </Box>
  );
};

export { InlineCountdownTimer };
